import BehaviorConfig from '@/models/app-config/behavior/behavior'

/**
 * 再入荷リクエストの受付手段に LINE が含まれるか.
 *
 * 商品詳細の入荷リクエストUIが LINE ボタンを出すかどうかと同じ設定
 * (behavior `itemDetail.itemRequest.allowAppKind`)で決める.
 * カート側で別の基準を持つと、詳細で LINE を案内していないブランドに LINE を示してしまうため.
 */
export function acceptsRestockRequestViaLine(behavior: BehaviorConfig): boolean {
  return behavior.itemDetail.itemRequest.allowAppKind.includes('line')
}
